export const isPublicPath = (pathname) =>
  pathname.startsWith("/auth") || pathname === "/error"
